<script lang="ts">
	import { type Achievement } from '../../../domain/Achievement';
	import AchievementSponsoredTag from '$components/home/achievement/elements/AchievementSponsoredTag.svelte';
	import { onViewport } from '$services/tracking/IntersectionObserver';

	export let achievement: Achievement;
	export let display: 'row' | 'grid';
	export let index: number;
	export let onViewPortCallback: Function | null = null;

	const enterViewPortFn = (...args : any) => {
		if(onViewPortCallback && args[0]) {
			const event: CustomEvent = args[0];
			onViewPortCallback(event);
		}
	};

</script>

<div
	class:grid-card-container={display==="grid"}
	class:row-card-container={display==="row"}
	data-testid="achievement-base-card"
	data-achievement-id={achievement.achievementId}
	data-feature-id="Achievement_Tile_{index}"
	data-feature-position="{index}"
	on:enterViewport={enterViewPortFn}
	use:onViewport
>
	<slot></slot>
	{#if achievement.content.sponsor}
		<div
			class="oc-pt-50"
			class:grid-sponsor-tag={display==="grid"}
			class:row-sponsor-tag={display==="row"}
		>
			<AchievementSponsoredTag achievementId={achievement.achievementId} />
		</div>
	{/if}
</div>

<style lang="scss">
  .row-card-container {
    position: relative;
    margin-bottom: 30px;
		display: grid;
  }

  .grid-card-container {
    display: flex;
    flex-direction: column;
  }

  .grid-sponsor-tag {
    align-self: end;
  }

  .row-sponsor-tag {
    position: absolute;
    right: 0;
    bottom: -30px;
  }
</style>
